// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../variables.css\"","mobile-threshold-width":"610px","mobileBackground":"mobileStyle_mobileBackground__2X9pH"};